module.exports = __webpack_public_path__ + "img/preview.3c6ea8a6.png";